import { classNames } from 'utils'

export default function InputError({ message, className }) {
  return message && <p className={classNames('text-sm text-rose-600', className)}>{message}</p>
}
